/** Fallback quando login por conta Shopify está indisponível na API. */
export const LOJA_WIZARD_STEPS_REMOTE = [
  {
    id: 'shop',
    label: 'Sua loja',
    crumb: 'LOJA',
    title: 'Conectar loja Shopify',
    subtitle: 'Informe o domínio admin da loja (minhaloja.myshopify.com) para abrir a autorização na Shopify.',
    hint: 'Domínio',
  },
  {
    id: 'install',
    label: 'App Torre',
    crumb: 'INSTALAÇÃO',
    title: 'Autorize o app',
    subtitle: 'A Shopify pede permissão para produtos, vendas e webhooks. Aceite na janela que abrimos.',
    hint: 'OAuth',
  },
  {
    id: 'import',
    label: 'Importação',
    crumb: 'DADOS',
    title: 'Importando tudo',
    subtitle: 'Registramos webhooks e puxamos produtos e pedidos. Pode levar alguns minutos em lojas grandes.',
    hint: 'Sync',
  },
];

export const LOJA_WIZARD_STEPS = [
  {
    id: 'login',
    label: 'Conta Shopify',
    crumb: 'ACESSO',
    title: 'Entre com a Shopify',
    subtitle: 'Entre com a conta que administra a loja na Shopify. Depois escolha a loja — a Torre abre a instalação do app.',
    hint: 'Login',
  },
  {
    id: 'waiting',
    label: 'Autorização',
    crumb: 'CONFIRMAÇÃO',
    title: 'Confirme na Shopify',
    subtitle: 'Na aba que abrimos, entre com a conta que administra a loja e aprove o código.',
    hint: 'Aguardando',
  },
  {
    id: 'stores',
    label: 'Sua loja',
    crumb: 'LOJA',
    title: 'Escolha a loja',
    subtitle: 'Admin: «Criar app» (Summit — app custom na org) e depois «Instalar» (OAuth). «Instalar» sem criar usa o app publicado da App Store.',
    hint: 'Escolher',
  },
  {
    id: 'install',
    label: 'App Torre',
    crumb: 'INSTALAÇÃO',
    title: 'Autorize na Shopify',
    subtitle: 'A Shopify abre a tela de permissões (app/grant) do app Torre de Controle — isso é a instalação nativa do app, não um app novo por loja.',
    hint: 'OAuth',
  },
  {
    id: 'import',
    label: 'Importação',
    crumb: 'DADOS',
    title: 'Importando tudo',
    subtitle: 'Registramos webhooks e puxamos produtos e pedidos. Pode levar alguns minutos em lojas grandes.',
    hint: 'Sync',
  },
];

export const SHOPIFY_PERMISSIONS = [
  { code: 'read_products', required: true, description: 'Ver e importar seus produtos.' },
  { code: 'read_orders', required: true, description: 'Ver e importar vendas.' },
  {
    code: 'read_all_orders',
    required: false,
    description: 'Histórico completo (opcional no app — se não estiver na versão Release, a Torre conecta mesmo assim).',
  },
];

export const SHOPIFY_DEVICE_ERRORS = {
  ACCESS_DENIED: 'Login na Shopify negado — tente de novo.',
  EXPIRED: 'O código expirou — comece de novo.',
  AUTH_FAILED: 'Não foi possível concluir o login na Shopify.',
  ENUMERATION_FAILED: 'Não conseguimos listar suas lojas — tente de novo.',
  SESSION_STORE_FAILED: 'Sessão CLI expirou — volte ao passo 1 e entre com a Shopify de novo.',
};

export const SHOPIFY_INSTALL_ERRORS = {
  ACCESS_DENIED: 'Você não autorizou o app na Shopify.',
  NEGADO: 'Você não autorizou o app na Shopify.',
  MISSING_SCOPES: 'A Shopify não liberou todas as permissões necessárias.',
  AUTH_FAILED: 'Falha ao instalar o app — tente de novo.',
  STATE_EXPIRED: 'O link de instalação expirou — use «Abrir Shopify» de novo na Torre.',
  UPSERT_FAILED: 'Não foi possível salvar a loja na Torre.',
  escopo: 'A Shopify não liberou todas as permissões necessárias.',
  falha: 'Não foi possível instalar o app — tente de novo.',
  app: 'App da Torre não configurado na API (Client ID/secret).',
};

export const SHOPIFY_SYNC_PHASES = [
  { key: 'queued', label: 'Fila de importação' },
  { key: 'products', label: 'Produtos' },
  { key: 'orders', label: 'Vendas' },
  { key: 'done', label: 'Pronto' },
];
